"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusPagesEnum = void 0;
var BonusPagesEnum;
(function (BonusPagesEnum) {
    BonusPagesEnum["Referral"] = "referral";
    BonusPagesEnum["Cashback"] = "cashback";
    BonusPagesEnum["Casino"] = "casino";
    BonusPagesEnum["Casino2"] = "casino_2";
    BonusPagesEnum["Promo2"] = "promo_2";
    BonusPagesEnum["Promo3"] = "promo_3";
    BonusPagesEnum["Promo4"] = "promo_4";
    BonusPagesEnum["Promo5"] = "promo_5";
    BonusPagesEnum["Promo6"] = "promo_6";
    BonusPagesEnum["Aviator"] = "aviator";
})(BonusPagesEnum || (exports.BonusPagesEnum = BonusPagesEnum = {}));
//# sourceMappingURL=bonuses.js.map